import Css from '../css/loader.css';

function App() {
return (

    <div id="loadingOverlay">
        <div class="spinner"></div>
    </div>
)};

export default App;